import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import axios from "axios";
import { Icon } from "@chakra-ui/react";
import { FaCloudUploadAlt } from "react-icons/fa";
import { Button } from "@chakra-ui/react";
import { t } from "i18next";
import { withTranslation } from "react-i18next";

class TldrDropzone extends Component {
  signal = axios.CancelToken.source();
  onDrop = (acceptedFiles) => {
    if (acceptedFiles.length <= 0) {
      return;
    }
    this.props.onDrop(acceptedFiles, this.signal);
  };

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  handleBtnOnClick = (e, open) => {
    e.stopPropagation();
    if (open) {
      open();
    }
  };

  render() {
    const {
      isUploading,
      btnTitle,
      description,
      className,
      sectionClassName,
      btnClassName,
      t,
      dropzoneProps,
    } = this.props;

    return (
      <>
        <Dropzone
          onDrop={(acceptedFiles) => this.onDrop(acceptedFiles)}
          {...dropzoneProps}
        >
          {({ getRootProps, getInputProps, open }) => (
            <section className={sectionClassName}>
              <div {...getRootProps({ className: `dropzone ${className}` })}>
                <input
                  {...getInputProps()}
                  onClick={(e) => {
                    if (this.props.handleInputOnClick) {
                      this.props.handleInputOnClick(e);
                    }
                  }}
                />
                <Icon as={FaCloudUploadAlt} h={6} w={6} />
                <p>{description}</p>
                <Button
                  onClick={(e) => {
                    this.handleBtnOnClick(e, open);
                  }}
                  size="md"
                  isLoading={isUploading}
                  loadingText={t("uploading")}
                  style={{ width: `${this.props.buttonWidth}%` }}
                  variant="secondary"
                >
                  {btnTitle}
                </Button>
              </div>
            </section>
          )}
        </Dropzone>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  pagestore: state.pagestore,
  websockets: state.websockets,
  story: state.story,
  editor: state.editor,
});

TldrDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  handleBtnOnClick: PropTypes.func.isRequired,
  dropzoneProps: PropTypes.object,
};

TldrDropzone.defaultProps = {
  isUploading: false,
  description: t("upload_msg", { ns: "common" }),
  btnTitle: t("upload_btn", { ns: "common" }),
  buttonWidth: 100,
  disableInput: false,
  sectionClassName: "",
  handleBtnOnClick: () => {},
  btnClassName: "",
  dropzoneProps: {},
};

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TldrDropzone)
);
